import * as React from 'react';
import { Thunks } from 'store/utils';
import { fetchModel } from 'features/page-model/ducks/get-model';
import { fetchStores } from 'features/stores/ducks/get-stores';
import { fetchStoreDetail } from 'features/store/ducks/get-store-by-id';
import { SHOP_URL } from 'common/constants';
import { patchPath } from 'utils/patch-path';
import { StoreList } from '../store-list/store-list';
import { Store } from '../store/store';

export type Route = {
  key: React.Key;
  component?: React.ElementType;
  path: string | string[];
  exact?: boolean;
  strict?: boolean;
  routes?: Route[];
  thunks: Thunks;
};
export type RootRoute = Route & {
  routes: Route[];
};

export const routes: RootRoute[] = [
  {
    key: 'Store',
    component: Store,
    path: patchPath([`${SHOP_URL}/:store`]),
    exact: true,
    strict: false,
    routes: [],
    thunks: [fetchModel(), fetchStoreDetail()],
  },
  {
    key: 'StoreList',
    component: StoreList,
    path: patchPath([SHOP_URL]),
    exact: true,
    strict: false,
    routes: [],
    thunks: [fetchModel(), fetchStores()],
  },
];
